<h1 class="text-effect" [attr.aria-label]="input">
  <span *ngFor="let x of selectedArray">{{ x }}</span>
</h1>
